exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1nZ4a-7_3_0 {\n  align-items: center;\n  border-radius: 2px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.26);\n  color: #ffffff;\n  display: flex;\n  font-size: 15px;\n  max-height: 75px;\n  min-height: 48px;\n  padding: 12px 24px;\n  width: 550px; }\n  .F3q8B-7_3_0 {\n    background-color: #d62c2f; }\n  ._287Xl-7_3_0 {\n    background-color: #0b8626; }\n  ._3dk_j-7_3_0 {\n    font-size: 24px; }\n  ._3epF9-7_3_0 {\n    font-weight: bold;\n    margin-left: 16px;\n    overflow: hidden;\n    max-height: 52px; }\n", ""]);

// Exports
exports.locals = {
	"core-toast": "_1nZ4a-7_3_0",
	"core-toast--error": "F3q8B-7_3_0",
	"core-toast--success": "_287Xl-7_3_0",
	"core-toast__icon": "_3dk_j-7_3_0",
	"core-toast__label": "_3epF9-7_3_0"
};